import React, { useState } from 'react'
import Selecteddata from "./table/Selecteddata";
import Selectiondata from "./table/Selectiondata";
import { Formik, Form, Field, FieldArray, FastField } from "formik";
export default function PrintbarcodeBoxes() {
    const [ShowstatusDropDown, setShowstatusDropDown] = useState(false);
    const [ShowsupplierDropDown, setShowsupplierDropDown] = useState(false);
    const [ShowcompanyDropDown, setShowcompanyDropDown] = useState(false);
  
    const [Users, setUsers] = useState([
      {
        full_name: "",
      },
    ]);
    const initialValues = {
      name: "",
      users: "",
      street_name: "",
      door_number: "",
      country: "",
      city: "",
      phone_number: "",
      website: "",
      contacts: [],
    };
    const onSubmit = (values, onSubmitProps) => {};
    const RemoveTemplateHandler = (remove, index) => {
      remove(index);
    };
    const AddTemplateHandler = (push) => {
      push({
        name: "",
        job_role: "",
        phone_number: "",
        email: "",
      });
    };
  return (
    <div>
    <div>
      <h2 className="font-Montserrat text-xl font-bold text-black">
        Print Barcode
      </h2>
      <div className="border-b-2 border-blue-200 w-20"></div>
    </div>
    <div className="mt-6">
      <h2 className="font-Montserrat  font-medium text-base text-black">
        Print barcode for items & Assemblies
      </h2>
    </div>
    <div className="flex flex-wrap justify-center ">
      <div
        className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
        // "w-[calc(100vw_-_12rem)]"
      >
        {/* <Itemsdata /> */}
        <Selectiondata />
      </div>
    </div>
    <div className="text-center w-fit align-middle m-auto text-blue-400 cursor-pointer pb-2">
      {" "}
      <button
        type="button"
        class="text-blue-900  bg-white border shadow-md  font-medium rounded-lg text-sm px-2 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
      >
      <svg className="relative left-1.5" width="26" height="28" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 16.5L8.08537 3L15 16.5" stroke="#1F78B4" stroke-width="2" stroke-linecap="round"/>
      </svg>
      </button>
      <button
      type="button"
      class="text-blue-900  bg-white border shadow-md  font-medium rounded-lg text-sm px-2 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
    >
    <svg className="relative left-1.5" width="26" height="28" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 1L8.41463 14.5L1.5 0.999999" stroke="#1F78B4" stroke-width="2" stroke-linecap="round"/>
    </svg>
    </button>
    </div>

    <div className="flex flex-wrap justify-center">
      <div
        className="tabelcontainer flex-auto  overflow-auto mx-4"
        // "w-[calc(100vw_-_12rem)]"
      >
        {/* <Itemsdata /> */}
        <Selecteddata />
      </div>
    </div>
    <div className="ml-12">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        //   validationSchema={validationSchema}
        //   validateOnMount
      >
        <Form>
          <div className="grid space-y-8">
            <Field name="purchasedate">
              {(props) => {
                const { field, form, meta } = props;
                return (
                  <>
                    {/* <svg
width="15"
height="20"
viewBox="0 0 15 15"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
  fill="black"
  fill-opacity="0.7"
/>
</svg> */}

                    <input
                      {...field}
                      type="date"
                      {...(meta.touched && meta.error
                        ? {
                            className:
                              "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                          }
                        : {
                            className:
                              "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                          })}
                      placeholder="Purchase Date"
                    ></input>
                    {meta.touched && meta.error ? (
                      <label className="text-xs font-Montserrat text-red-500">
                        <span className="ml-1">{meta.error}</span>
                      </label>
                    ) : null}
                  </>
                );
              }}
            </Field>
            <Field name="arrivaldate">
              {(props) => {
                const { field, form, meta } = props;
                return (
                  <>
                    {/* <svg
width="15"
height="20"
viewBox="0 0 15 15"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path
d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
fill="black"
fill-opacity="0.7"
/>
</svg> */}

                    <input
                      {...field}
                      type="date"
                      {...(meta.touched && meta.error
                        ? {
                            className:
                              "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                          }
                        : {
                            className:
                              "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                          })}
                      placeholder="Arrival Date"
                    ></input>
                    {meta.touched && meta.error ? (
                      <label className="text-xs font-Montserrat text-red-500">
                        <span className="ml-1">{meta.error}</span>
                      </label>
                    ) : null}
                  </>
                );
              }}
            </Field>
            <Field name="supplier">
              {(props) => {
                const { field, form, meta } = props;
                return (
                  <>
                    <button
                      id="dropdownButton"
                      className=" font-Montserrat border-solid border-gray
focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                      type="button"
                      onClick={() =>
                        setShowsupplierDropDown(!ShowsupplierDropDown)
                      }
                    >
                      Select Supplier
                      <svg
                        className="w-4 h-4 ml-auto"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </button>
                    {ShowsupplierDropDown ? (
                      <div>
                        <div
                          id="dropdown"
                          className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                        >
                          <ul
                            className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                            aria-labelledby="dropdownRightButton"
                            {...field}
                          >
                            <li>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type A
                              </a>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type B
                              </a>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type C
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ) : null}
                  </>
                );
              }}
            </Field>
            <Field name="tracking">
              {(props) => {
                const { field, form, meta } = props;
                return (
                  <>
                    {/* <svg
  width="15"
  height="20"
  viewBox="0 0 15 15"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
    fill="black"
    fill-opacity="0.7"
  />
</svg> */}

                    <input
                      {...field}
                      type="number"
                      {...(meta.touched && meta.error
                        ? {
                            className:
                              "border-b-2 bg-transparent font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                          }
                        : {
                            className:
                              "border-b-2 bg-transparent font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                          })}
                      placeholder="Tracking Id"
                    ></input>
                    {meta.touched && meta.error ? (
                      <label className="text-xs font-Montserrat text-red-500">
                        <span className="ml-1">{meta.error}</span>
                      </label>
                    ) : null}
                  </>
                );
              }}
            </Field>
            <Field name="company">
              {(props) => {
                const { field, form, meta } = props;
                return (
                  <>
                    <button
                      id="dropdownButton"
                      className=" font-Montserrat border-solid border-gray
focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                      type="button"
                      onClick={() =>
                        setShowcompanyDropDown(!ShowcompanyDropDown)
                      }
                    >
                      Delivery Company
                      <svg
                        className="w-4 h-4 ml-auto"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </button>
                    {ShowcompanyDropDown ? (
                      <div>
                        <div
                          id="dropdown"
                          className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                        >
                          <ul
                            className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                            aria-labelledby="dropdownRightButton"
                            {...field}
                          >
                            <li>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type A
                              </a>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type B
                              </a>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type C
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ) : null}
                  </>
                );
              }}
            </Field>
            <Field name="status">
              {(props) => {
                const { field, form, meta } = props;
                return (
                  <>
                    <button
                      id="dropdownButton"
                      className=" font-Montserrat border-solid border-gray
focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                      type="button"
                      onClick={() =>
                        setShowstatusDropDown(!ShowstatusDropDown)
                      }
                    >
                      Select Status
                      <svg
                        className="w-4 h-4 ml-auto"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </button>
                    {ShowstatusDropDown ? (
                      <div>
                        <div
                          id="dropdown"
                          className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                        >
                          <ul
                            className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                            aria-labelledby="dropdownRightButton"
                            {...field}
                          >
                            <li>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type A
                              </a>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type B
                              </a>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                Type C
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    ) : null}
                  </>
                );
              }}
            </Field>
          </div>
        </Form>
      </Formik>
    </div>

    <div className="flex flex-row justify-center my-10">
      <button
        type="button"
        className="text-red-600 font-Montserrat space-x-128  font-medium text-lg"
        // onClick={() => Navigate("/dashboard/management/customer-dashboard")}
      >
        Cancel
      </button>

      <button
        type="submit"
        className="text-white ml-auto space-x-128  bg-green-100 hover:bg-green-200 font-Montserrat font-semibold  place-content-center rounded-md py-1 px-8 flex flex-shrink-1 "
        // onClick={() =>
        //   navigate("/dashboard/warehouse/printscan/printbarcode-batches")
        // }
      >
        Print Barcode
      </button>
    </div>
  </div>
  )
}
